import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { axiosApi } from "../../../constants/axios_api";
import appUrl from "../../../constants/appUrl";

const SetWinningFlag = () => {
    const [selectedType, setSelectedType] = useState(null);

    const handleWinningFlagSubmit = async () => {
        let payload = { type: selectedType };

        if (selectedType === "random") {
            const count = document.getElementById("count").value;
            if (count) {
                payload.count = parseInt(count, 10);
            }
        } else if (selectedType === "specific") {
            const userIds = document.getElementById("userId").value;
            if (userIds) {
                payload.userIds = userIds.split(",").map((id) => id.trim());
            }
        }

        try {
            const response = await axiosApi.post(`${appUrl.baseUrl}api/prizeRouter/setWinningFlag`, payload);
            console.log("Response:", response.data);
            toast.success(response.data.data.message);
        } catch (error) {
            console.error("Error:", error.response ? error.response.data : error.message);
            toast.error(error.response ? error.response.data.message : error.message);
        }
    };

    return (
        <div className="custom-dialog">
            <h3>Set Winning Flag</h3>
            <Dropdown
                options={[
                    { label: "All", value: "all" },
                    { label: "Half", value: "half" },
                    { label: "First 20", value: "first_20" },
                    { label: "Last 20", value: "last_20" },
                    { label: "Random", value: "random" },
                    { label: "Specific", value: "specific" },
                ]}
                placeholder="Type"
                value={selectedType}
                style={{ width: "50%" }}
                onChange={(e) => setSelectedType(e.value)}
            />
            {selectedType === "random" && (
                <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <label htmlFor="count">Count</label>
                    <InputText id="count" style={{ width: "100%", marginTop: "5px" }} placeholder="Enter count" />
                </div>
            )}
            {selectedType === "specific" && (
                <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <label htmlFor="userId">User ID</label>
                    <InputText id="userId" style={{ width: "100%", marginTop: "5px" }} placeholder="Enter User ID" />
                </div>
            )}
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Button label="Submit Winning Flag" icon="pi pi-check" className="p-button-success mt-3" onClick={handleWinningFlagSubmit} />
            </div>
        </div>
    );
};

export default SetWinningFlag;
